import Sidemenu from "../../components/sidemenu";
import { useState, useEffect } from "react";
import parser from "papaparse";
import * as Styled from './styled';
import { useNavigate } from "react-router-dom";
import InputSuggestion from "../../components/elements/inputSuggestion";
import { functionService } from "../../lib/functions";


const UploadShortlist = () => {
    let navigate = useNavigate();
    const [recruitersList, setRecruitersList] = useState([]);
    const [recruiterSearchedRoles, setRecruiterSearchedRoles] = useState([]);
    const [selectedRecruiterEmail, setSelectedRecruiterEmail] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [successUpload, setSuccess] = useState(false);
    const [filename, setFileName]  = useState()
    const [selectedRecruiterId, setSelectedRecruiterId] = useState(null);
    const [selectedSearchId, setSelectedSearchId] = useState(null);
    const [emailsList, setEmailsList] = useState([]);
    const [message, setMessage] = useState('');


    useEffect(()=> {
        functionService.get(`recruiter/get-all-recuiters?searchtext=`).then(res => {
            if(res.status)
                setRecruitersList(res?.response?.data?.data);
            else
                setRecruitersList({email : 'No Data!!!!', id: 'NA'});
        });

    },[])

    useEffect(()=> {
        if(selectedRecruiterId){
            functionService.post('recruiter/get-recuiter-searches?searchtext=', {recruiter_id: selectedRecruiterId}).then(res => {
                if(res.status)
                    setRecruiterSearchedRoles(res?.response?.data?.data);
                else
                    setRecruiterSearchedRoles({role : 'No Data!!!!', id: 'NA'});
            });
        }
    }, [selectedRecruiterId])

    const approveShortlist = (status)=> {
        if(emailsList.length>0){
            functionService.post(`recruiter/addshortlist-byemail`, {recruiterId: selectedRecruiterId, searchId: selectedSearchId, emailsList, status}).then(res => {
                setSuccess(false);
                setMessage(res?.response?.data?.data || `Candidates ${status}`);
            });
        }
    }


    const selectRecruiter = (list, recruiterEmail, recruiterId) => {
        setSelectedRecruiterEmail(recruiterEmail);
        setSelectedRecruiterId(recruiterId);
    }

    const searchRecruiter = (listname, searchText) => {
        functionService.get(`recruiter/get-all-recuiters?searchtext=${searchText}`).then(res => {
            if(res.status)
                setRecruitersList(res?.response?.data?.data);
            else
                setRecruitersList({email : 'No Data!!!!', id: 'NA'});
        });
    }

    const selectRole = (list, role, searchId) => {
        setSelectedRole(role);
        setSelectedSearchId(searchId);
    }

    const searchRole = (listname, searchText) => {
        functionService.post(`recruiter/get-recuiter-searches?searchtext=${searchText}`, {recruiter_id : selectedRecruiterId}).then(res => {
            if(res.status)
                setRecruiterSearchedRoles(res?.response?.data?.data);
            else
                setRecruiterSearchedRoles({email : 'No Data!!!!', id: 'NA'});
        });
    }



    const handleFile = (e) => {
        try {
            if (e.target.files !== undefined) {
                setFileName(e.target.files[0]?.name);
                parser.parse(e.target?.files[0], {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                        setSuccess(true);
                        const emails = [];
                        if(results?.length === 0)
                            setMessage("No Emails in the List!!!!!!")
                        results?.data?.map((res => {
                            emails.push(res?.Email_Address || res?.email || res?.['E-mail']);
                        }))
                        setEmailsList(emails);
                    },
                });
            }
        } catch (err) {
            setMessage(err['message']);
            console.log("ERROROREOR", err);
        }
    };


    return (
        <Styled.MainDiv>
            <Sidemenu />
            <Styled.CLMWrap>
                <Styled.Header style={{marginBottom: '20px'}}>Upload Shortlist</Styled.Header>
                <Styled.CLMContent>
                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Select Recruiter</Styled.InputTitleDiv>
                        <InputSuggestion 
                            placeholder="Enter reruiter email" 
                            list={recruitersList} 
                            value="id" 
                            name="recruiters_list" 
                            selected={selectRecruiter} 
                            change={searchRecruiter} 
                            width="600px" 
                            height="55px" 
                            option="email" 
                            active={selectedRecruiterEmail} 
                            showLast
                        />
                    </Styled.InputWrap>
                    {selectedRecruiterId &&
                        <Styled.InputWrap>
                            <Styled.InputTitleDiv>Select Candidate Search done by recruiter</Styled.InputTitleDiv>
                            <InputSuggestion 
                                placeholder="Select a Saved Search" 
                                list={recruiterSearchedRoles} 
                                value="id" 
                                name="searched_roles_list" 
                                selected={selectRole} 
                                change={searchRole} 
                                width="600px" 
                                height="55px" 
                                option="role" 
                                active={selectedRole} 
                                showLast
                            />
                        </Styled.InputWrap>
                    }
                    <Styled.UploadDivWrap>
                        {!successUpload ? 
                            <label
                                for="upload"
                                style={{
                                    border: "1px dashed #c29f9f",
                                    borderRadius: "10px",
                                    padding: "20px",
                                    background: "#F6FAFF",
                                    marginBottom: "10px",
                                    display: "flex",
                                    flexDirection: 'column',
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: !selectedRecruiterId && !selectedRole ? "not-allowed" : 'pointer' 
                                }}
                            >
                                <Styled.UploadCoverImage>
                                    <img
                                        src = '/upload.svg'
                                        style={{ marginRight: "10px" }}
                                    />
                                </Styled.UploadCoverImage>
                                <input
                                    onChange={handleFile}
                                    type="file"
                                    id="upload"
                                    style={{ padding: "0px 20px"}}
                                    hidden
                                    accept=".csv"
                                    disabled = {!selectedRecruiterId && !selectedRole}
                                />
                                <div
                                    style={{
                                        display: "Flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <p
                                        style={{
                                            fontStyle: "normal",
                                            fontFamily: 'Basis Grotesque Pro',
                                            fontWeight: 700,
                                            fontSize: "14px",
                                            lineHeight: "17px",
                                            color: "#1E2228",
                                            marginTop: 0,
                                            marginBottom: '5px',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {" "}
                                        Choose file to upload
                                    </p>
                                    <span
                                        style={{
                                            fontStyle: "normal",
                                            fontFamily: 'SF Pro Text',
                                            fontWeight: 400,
                                            fontSize: "12px",
                                            lineHeight: "14px",
                                            color: "#506D85",
                                            textAlign: 'center'
                                        }}
                                    >
                                        {" "}
                                        Allowed file format : .csv
                                    </span>
                                </div>
                            </label>
                        :
                            <div>
                                <label
                                    for="success"
                                    style={{
                                        border: "1px dashed #c29f9f",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        background: "#F6FAFF",
                                        width: "50%",
                                        marginBottom: "10px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <img src="/excel.png" />
                                    <div
                                        style={{
                                            display: "Flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                        }}
                                    >
                                        <p
                                            style={{
                                                lineHeight: 0,
                                                fontStyle: "normal",
                                                fontWeight: 700,
                                                fontSize: "14px",
                                                marginBottom: 0,

                                                color: "#1E2228",
                                            }}
                                        >
                                            {" "}
                                            {filename}
                                        </p>
                                    </div>
                                    <Styled.UploadCoverImageSuccess>
                                        <img src="/check.svg" />
                                    </Styled.UploadCoverImageSuccess>
                                </label>
                            </div>
                        }
                    <a href="/Shortlist_sample.csv" style={{textDecorationLine: "none", fontSize: '12px', fontWeight: '400'}}>
                        Download Sample File
                    </a>
                    </Styled.UploadDivWrap>
                    
                    <Styled.ButtonWrap>
                        <Styled.Button 
                            onClick={() => {navigate("/candidateRequest", { replace: true })}}
                            style={{
                                fontFamily: 'inter', 
                                fontSize: '12px', 
                                fontWeight: '600', 
                                lineHeight: '14.52px', 
                                color: '#1B49EA', 
                                background: '#FFF',
                                border: '1px solid #1B49EA',
                                borderRadius: '6px',
                                marginRight: '20px', 
                                padding: '0px 20px'
                              }}
                        >
                            Cancel
                        </Styled.Button>
                        <Styled.Button 
                            style={{marginRight: '10px'}}
                            onClick={()=> approveShortlist("CONFIRMED")} 
                            disabled = {emailsList.length === 0} 
                        >
                            Upload & Approve
                        </Styled.Button>
                        <Styled.Button 
                            onClick={()=> approveShortlist("SHORTLISTED")} 
                            disabled = {emailsList.length === 0} 
                        >
                            Upload & Shortlist
                        </Styled.Button>
                    </Styled.ButtonWrap>
                </Styled.CLMContent>
                <Styled.Footer>
                    <p>{message}</p>
                </Styled.Footer>
            </Styled.CLMWrap>
        </Styled.MainDiv>
    )
}

export default UploadShortlist;